import { Inject, Injectable } from '@angular/core';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Store } from '@app/common/store';
import { FeatureSetting } from '@app/models/feature-setting';
import { EnvironmentFeatureSettings } from '@environments/environment-feature-settings';
import { Environment } from '@environments/interface.environment';

@Injectable({
  providedIn: 'root'
})
export class FeatureSettingsStoreService extends Store<EnvironmentFeatureSettings> {

  constructor(@Inject(CUSTOMERENVIRONMENT) environment: Environment) {
    super({ ...new EnvironmentFeatureSettings(), ...environment.featureSettings } as EnvironmentFeatureSettings);
  }

  private setValueOfSetting(settingFromDb: FeatureSetting, settingKey: string) {
    if (settingFromDb.DataType === 'boolean' || settingFromDb.DataType === 'number' || settingFromDb.DataType === 'object') {
      this.state[settingKey] = JSON.parse(settingFromDb.Value);
    } else {
      this.state[settingKey] = settingFromDb.Value;
    }
  }

  updateState(featureSetting: FeatureSetting) {
    this.setValueOfSetting(featureSetting, featureSetting.Id);
    this.setState(this.state);
  }
}
